import service from '@/utils/request.js'
export function getSheetId() {
  return service.request({
    method: 'get',
    url: '/front/frontMaterialSheet/getEnableSheetList',
  });
}


export function getMajorList(params) {
  return service.request({
    method: 'get',
    url: '/teacher/controller/facultyinfo/queryCourseSpecialty',
    params
  });
}



export function querySchoolSquadList(params) {
  return service.request({
    method: 'get',
    url: '/teacher/controller/facultyinfo/querySchoolSquadList',
    params
  });
}

export function queryTeacherCourseList(params) {
  return service.request({
    method: 'get',
    url: '/teacher/controller/facultyinfo/queryTeacherCourseList',
    params
  });
}


export function queryCourseFaculty() {
  return service.request({
    method: 'get',
    url: '/teacher/controller/facultyinfo/queryCourseFaculty',
  });
}

export function verificationMaterialSheetInfo(materialId, period) {
  return service.request({
    method: 'get',
    url: `/front/frontMaterialSheet/verificationMaterialSheetInfo/${materialId}/${period}`
  });
}

export function addBook(par) {
  return service.request({
    method: 'post',
    url: '/front/frontMaterialSheet/batchInsertMaterialSheet',
    data: par
  });
}



export function updateBookList(data) {
  return service.request({
    method: 'post',
    url: '/teacher/controller/teacherselectbookinfo/upSubmit',
    data
  });
}


export function fetchBookList(params) {
  return service.request({
    method: 'get',
    url: `/teacher/controller/teacherselectbookinfo/listSemesterBooks`,
    params
  });
}

export function fetchApplaySattus(data) {
  return service.request({
    method: 'get',
    url: `/teacher/controller/stylebookapplyinfo/haveApply`,
    params: data
  });
}
export function addDemoBook(data) {
  return service.request({
    method: 'post',
    url: `/teacher/controller/stylebookapplyinfo/save`,
    data
  });
}


export function fetchSmapleBookList(data) {
  return service.request({
    method: 'get',
    url: `/teacher/controller/stylebookapplyinfo/list`,
    params: data
  });
}

export function fetchSmapleBookDetail(id) {
  return service.request({
    method: 'get',
    url: `/teacher/controller/stylebookapplyinfo/info/${id}`,
  });
}

export function updatePwd(data) {
  return service.request({
    method: 'post',
    url: `/teacher/business/schooluserinfo/updatePassword`,
    data
  });
}


export function fetchPublishList(data) {
  return service.request({
    method: 'get',
    url: `/teacher/business/teacherpublishpressinfo/list`,
    params:data
  });
}
export function savePublish(data) {
  return service.request({
    method: 'post',
    url: `/teacher/business/teacherpublishpressinfo/save`,
    params:data
  });
}
export function deletePublish(data) {
  return service.request({
    method: 'post',
    url: `/teacher/business/teacherpublishpressinfo/delete`,
    data
  });
}
export function fetchReasonById(data) {
  return service.request({
    method: 'get',
    url: `/teacher/business/teacherpublishpressinfo/auditordetails`,
    params:data
  });
}
export function fetchPunblishDetail(id) {
  return service.request({
    method: 'get',
    url: `/teacher/business/teacherpublishpressinfo/info/${id}`,
  });
}

export function deleteBook(data) {
  return service.request({
    method: 'post',
    url: `/teacher/controller/teacherselectbookinfo/delete`,
    data
  });
}

export function cartBookList() {
  return service.request({
    method: 'get',
    url: `/teacher/controller/teacherselectbookinfo/listNowSemesterBooks`,
  });
}
export function rejectionReason(params) {
  return service.request({
    method: 'get',
    url: `/teacher/controller/teacherselectbookinfo/auditordetails`,
    params
  });
}
